export default "__VITE_ASSET__aee349c3__"